import React from "react";

export default function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="bg-[#F7F5F0] py-10 md:py-14 overflow-hidden border-y border-[#2A2A2A]/10" data-testid="marquee">
      <div className="marquee-track">
        {row.map((w, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-serif-display italic text-[#062029] text-5xl md:text-7xl px-8 md:px-14">
              {w}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#C5A880]" />
          </span>
        ))}
      </div>
    </div>
  );
}
